import { useFolderStore } from "../stores/folderStore";
import { normalizeFolders } from "./folderHelpers";
import { getApiBaseUrl } from "./apiConfig";

export async function refreshFolders(token: string | null): Promise<void> {
  try {
    const res = await fetch(`${getApiBaseUrl()}/mail/folders`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return;
    const data = await res.json();
    if (!data.folders || !Array.isArray(data.folders)) return;

    const store = useFolderStore.getState();
    const currentActive = store.activeFolderId;

    const normalized = normalizeFolders(data.folders);
    useFolderStore.getState().setFolders(normalized);

    if (currentActive) {
      useFolderStore.getState().setActiveFolder(currentActive);
    }
  } catch {
    // Silent fail - folder counts are not critical
  }
}
